import { render } from "./ButtonRoute.vue?vue&type=template&id=ae34365c&scoped=true"
import script from "./ButtonRoute.vue?vue&type=script&lang=js"
export * from "./ButtonRoute.vue?vue&type=script&lang=js"

import "./ButtonRoute.vue?vue&type=style&index=0&id=ae34365c&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae34365c"]])

export default __exports__